import { IGame, IGameActivity } from '@libs/interfaces';
import { pick } from 'lodash';

export const ParseGameNameFotUrl = (name: string, provider: string) =>
  name && provider ? `${provider.split(' ').join('_')}/${name.split(' ').join('_').replace('/', '@')}` : '';
export const ParseGame = (game: Partial<IGame>): Partial<IGame> => {
  return pick(game, ['category', 'external_id', 'demo_game_support', 'image', 'name', 'provider', 'type']);
};
export const GameImageUrl = (game: Partial<IGame> | IGameActivity) =>
  game?.provider && game?.name
    ? `https://lotodobicho.com/gallery/games-images/${game.provider}/${game.name.replace('/', '_')}.png`
    : '';

export const ProviderImageUrl = (provider_id: string) =>
  `https://lotodobicho.com/gallery/game-providers/short/${provider_id}.png`;
